// export const arabicNameValidation =
//   /^[\u0600-\u06FF][\u0600-\u06FF\s\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`]*[\u0600-\u06FF\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`]$/i;
export const arabicNameValidation =
  /^[\u0600-\u06FF\s\u064B-\u065F\u0670\u06D6-\u06ED]+$/;
export const arabicNameWithNoRestrictionValidation =
  /^[\u0600-\u06FF\s\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>~‘÷×?>`]+$/i;
export const adminNameValidation =
  /^[\u0600-\u06FFa-z][\u0600-\u06FFa-z\s\d$!@#%^&*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>?`]*[\u0600-\u06FFa-z\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`]$/i;
export const arabicWithEmojisNoRestriction =
  /^[\u0600-\u06FF\p{So}\p{Sc}\p{Sk}\p{Sm}\p{Zs}\d\p{P}\p{S}\p{Extended_Pictographic}\p{Emoji_Component}]+$/giu;
export const englishWithEmojisNoRestriction =
  /^[\w\s\p{Extended_Pictographic}\p{Emoji_Component}\p{So}\p{Sc}\p{Sk}\p{Sm}\p{Zs}\d\p{P}p{S}]+$/giu;
export const englishNameWithNoSpacesAtStartOrEnd =
  /^[a-z\d$!@#%^&*()_+-=\[\]/{}\\|;':",./<>?~`][a-z\s\d$!@#%^&*()_+-=\[\]/{}\\|;':",./<>?~`]*[a-z\d$!@#%^&*()_+-=\[\]/{}\\|;':",./<>?~`]$/i;
export const englishNameWithNoRestriction =
  /^[a-z\s\d$!@#%^&*()_+-=\[\]/{}\\|;':",./<>?~`]+$/i;
export const arabicNameWithNoSpacesAtStartOrEnd =
  /^[\u0600-\u06FF\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`][\u0600-\u06FF\s\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`]*[\u0600-\u06FF\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×>`]$/i;
export const startsWithArabicLetterRegex =
  /^[\d$!@#%^&?*()_+-=\[\]/\\{}|;':",./<>؟~؟’~‘÷×\s]*[\u0600-\u06FF\u064B-\u0652\u0618-\u061A\s]+/i;
export const theFirstEncounteredLetterIsArabic = /^([\d\W_]*)?[\u0600-\u06FF]/i;
export const englishLettersExist = /(?=.*[a-z])/i;
export const arabicLettersExist = /(?=.*[\u0621-\u064A])/i;
export const noSpacesAtStartOrEnd = /^[^\s]+(\s+[^\s]+)*$/;
export const englishAndArbicLettersAndSpacesOnly =
  /^[\u0600-\u06FF\sa-z\-']+$/i;
